module.exports = __webpack_public_path__ + "a734ef789d48c650e225bb56ffacdeca.svg";